import { EventEmitter } from "@angular/core";
import { BusinesLogicService } from "../../services/business-logic.service";
import { DataService } from "../../services/data.service";
import { ModalHelper } from "../../components/modal/modal.helper";
import { UtilsService } from "../../services/utils.service";
import { CallComponent } from "../call/call.component";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BusinessEventService } from "../../services/business-event.service";
import { TurnService } from "../../services/turn.service";
var StatusComponent = (function () {
    function StatusComponent(_blogic, _data, _utils, _modal, _turn, _bevent) {
        this._blogic = _blogic;
        this._data = _data;
        this._utils = _utils;
        this._modal = _modal;
        this._turn = _turn;
        this._bevent = _bevent;
        this.destroy$ = new Subject();
        this.websocketError = new EventEmitter();
        this.withButton = false;
        this.changeDeskStatusEnabled = true;
        this.queueResume = [];
        this.atypeResume = [];
        this.socketRetries = 0;
        this.totalInOffice = 0;
        this.loadingSocket = false;
    }
    StatusComponent.prototype.ngOnInit = function () {
        if (!this.withButton)
            this.initIoConnection();
        this.getAtypeStatus();
        this.getQueueStatus();
    };
    StatusComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    // Initialize SocketConnection
    StatusComponent.prototype.initIoConnection = function () {
        var _this = this;
        if (!this.loadingSocket) {
            this.loadingSocket = true;
            if (this.socketRetries != null)
                this.socketRetries++;
            if (this.subscriptionClose != null)
                this.subscriptionClose.unsubscribe();
            if (this.subscriptionOpen != null)
                this.subscriptionOpen.unsubscribe();
            if (this.ioConnection != null)
                this.ioConnection.unsubscribe();
            this.ioConnection = this._bevent
                .onMessage()
                .subscribe(function (response) {
                if (response["eventhook"] == "turninfo") {
                    _this.changeDeskStatus();
                    var dateReg = /^\d{4}[./-]\d{2}[./-]\d{2} \d{2}[.:]\d{2}[.:]\d{2}$/;
                    // Actualizamos listado de colas
                    var qResponse = response["message"]["qinfo"];
                    for (var i = 0; i < qResponse.length; i++) {
                        if (qResponse[i].initdatetime != null &&
                            !(typeof qResponse[i].initdatetime == "number") &&
                            qResponse[i].initdatetime.match(dateReg)) {
                            qResponse[i].initdatetime = _this._utils.getWaitTime(qResponse[i].initdatetime, null, false, false);
                        }
                        else {
                            qResponse[i].initdatetime = 0;
                        }
                    }
                    _this.queueResume = JSON.parse(JSON.stringify(qResponse));
                    _this.countTotalInWait();
                    // Actualizamos listado de tipos de atención
                    var kinds = _this._data.session["atypes"];
                    var availableKinds = [];
                    kinds.forEach(function (e) {
                        availableKinds.push(e.id);
                    });
                    var kResponse = response["message"]["kinfo"];
                    var parseResponse = [];
                    kResponse.forEach(function (e) {
                        if (availableKinds.indexOf(e.id) != -1) {
                            if (e.initdatetime != null &&
                                !(typeof e.initdatetime == "number") &&
                                e.initdatetime.match(dateReg)) {
                                e.initdatetime = _this._utils.getWaitTime(e.initdatetime, null, false, false);
                            }
                            else {
                                e.initdatetime = 0;
                            }
                            parseResponse.push(e);
                        }
                    });
                    if (parseResponse.length != 0) {
                        _this.atypeResume = JSON.parse(JSON.stringify(parseResponse));
                    }
                    else {
                        _this.atypeResume = [];
                    }
                }
            });
            this.subscriptionOpen = this._bevent
                .onOpen()
                .subscribe(function (response) {
                _this.loadingSocket = false;
            });
            this.subscriptionClose = this._bevent
                .onClose()
                .subscribe(function (response) {
                _this.loadingSocket = false;
                _this.initIoConnection();
            });
        }
    };
    /* Get queue status */
    StatusComponent.prototype.parseQueueStatus = function (response) {
        for (var i = 0; i < response.length; i++) {
            response[i].initdatetime = this._utils.getWaitTime(response[i].initdatetime, null, false, false);
        }
        this.queueResume = JSON.parse(JSON.stringify(response));
        this.countTotalInWait();
    };
    /* Get atypes status */
    StatusComponent.prototype.parseAtypeStatus = function (response) {
        for (var i = 0; i < response.length; i++) {
            response[i].initdatetime = this._utils.getWaitTime(response[i].initdatetime, null, false, false);
        }
        if (response.length != 0) {
            this.atypeResume = JSON.parse(JSON.stringify(response));
        }
    };
    /* Get queue status */
    StatusComponent.prototype.getQueueStatus = function () {
        var _this = this;
        this._blogic
            .getQueueInfo()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            for (var i = 0; i < response.length; i++) {
                response[i].initdatetime = _this._utils.getWaitTime(response[i].initdatetime, null, false, false);
            }
            _this.queueResume = JSON.parse(JSON.stringify(response));
            _this.countTotalInWait();
        });
    };
    StatusComponent.prototype.countTotalInWait = function () {
        var totalInOffice = 0;
        for (var i = 0; i < this.queueResume.length; i++) {
            totalInOffice = totalInOffice + this.queueResume[i].size;
        }
        this.totalInOffice = totalInOffice;
    };
    /* Get queue status */
    StatusComponent.prototype.getAtypeStatus = function () {
        var _this = this;
        var kinds = this._data.session["atypes"];
        var availableKinds = [];
        kinds.forEach(function (e) {
            availableKinds.push(e.id);
        });
        this._blogic
            .getKindInfo()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            var parseResponse = [];
            response.forEach(function (e) {
                if (availableKinds.indexOf(e.id) != -1) {
                    e.initdatetime = _this._utils.getWaitTime(e.initdatetime, null, false, false);
                    parseResponse.push(e);
                }
            });
            if (parseResponse.length != 0) {
                _this.atypeResume = JSON.parse(JSON.stringify(parseResponse));
            }
            else {
                _this.atypeResume = [];
            }
        });
    };
    /* Parse atype list using the desk id as key of array */
    StatusComponent.prototype._parseAtypes = function (atypes) {
        var filterArray = [];
        for (var i = 0; i < this._data.session["atypes"].length; i++) {
            for (var e = 0; e < atypes.length; e++) {
                if (this._data.session["atypes"][i][0] == atypes[e].name) {
                    filterArray.push(atypes[e]);
                }
            }
        }
        return filterArray;
    };
    /* Open status modal */
    StatusComponent.prototype.openStatusModal = function () {
        this._modal.show("statusModal");
    };
    /* Call queue from a specific atype */
    StatusComponent.prototype.callFromAtype = function (id) {
        var _this = this;
        var params = {
            filter: "queue",
            desk_id: this._data.session["desk"],
            status: "A",
            selschema: "K",
            selid: id,
            deskuser: this._data.session["username"],
            deskoperator: this._data.session["operator"],
        };
        this._blogic
            .deskNotify(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            var parse = response;
            if (parse["id"] == "-1") {
                _this._data.turn = null;
            }
            else {
                _this._data.turn = parse;
                _this._data.lastCalls.unshift(response);
            }
        });
    };
    StatusComponent.prototype.callFromQueue = function (id) {
        var _this = this;
        var params = {
            filter: "queue",
            desk_id: this._data.session["desk"],
            status: "A",
            selschema: "Q",
            selid: id,
            deskuser: this._data.session["username"],
            deskoperator: this._data.session["operator"],
        };
        this._blogic
            .deskNotify(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            var parse = response;
            if (parse["id"] == "-1") {
                _this._data.turn = null;
            }
            else {
                _this._data.turn = parse;
                _this._data.lastCalls.unshift(response);
            }
        });
    };
    StatusComponent.prototype.showAlert = function (value) {
        this.socketRetries = null;
        this.subscriptionClose.unsubscribe();
        this.subscriptionOpen.unsubscribe();
        this.ioConnection.unsubscribe();
        this._bevent.close();
        this.websocketError.emit(true);
    };
    StatusComponent.prototype.changeDeskStatus = function () {
        var _this = this;
        if (this._data.turn == null ||
            (this._data.turn["id"] && this._data.turn["id"] == -1)) {
            if (this.changeDeskStatusEnabled) {
                var params = {
                    desk_id: this._data.session["desk"],
                    status: "query",
                };
                this.changeDeskStatusEnabled = false;
                setTimeout(function () {
                    _this.changeDeskStatusEnabled = true;
                }, 1000);
                this._turn.startAutoSupervisor();
            }
        }
    };
    return StatusComponent;
}());
export { StatusComponent };
